/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Support_TextInputs */



/**
* | output |
* | --- |
* | "If this issue persists, please contact our support team:" |
*
* @param {Offline_Support_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_support_text = /** @type {((inputs?: Offline_Support_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Support_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Si ce problème persiste, veuillez contacter notre équipe de support :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sollte dieses Problem weiterhin bestehen, kontaktieren Sie bitte unser Support-Team:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Se il problema persiste, contatta il nostro team di supporto:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Если проблема не исчезнет, пожалуйста, свяжитесь с нашей службой поддержки:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Si el problema persiste, comuníquese con nuestro equipo de soporte:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("如果问题仍然存在，请联系我们的支持团队：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("この問題が解決しない場合は、サポート チームにお問い合わせください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यदि यह समस्या बनी रहती है, तो कृपया हमारी सहायता टीम से संपर्क करें:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Se o problema persistir, entre em contato com nossa equipe de suporte:")
	return /** @type {LocalizedString} */ ("If this issue persists, please contact our support team:")
});